import { useAtomValue } from 'jotai';

import { useTranslate } from '@growtherapy/i18n';
import { Button } from '@growtherapy/sprout-ui';

import { VisitorState, visitorStateAtom } from '../../state';
import { useAdmissionTrackingEvents } from './useAdmissionTrackingEvents';
import { useVisitorConnectRoomCallback } from './useVisitorConnectRoomCallback';

export function JoinSessionButton({ onJoin: handleJoin, isLoading }: { onJoin: () => void; isLoading: boolean }) {
  const t = useTranslate();
  return (
    <Button use='primary' size='md' className='w-full' onClick={handleJoin} loading={isLoading}>
      {t('telehealth-core:waitingRoom.joinSession')}
    </Button>
  );
}

export function JoinSessionButtonWrapper() {
  const connectRoom = useVisitorConnectRoomCallback();
  const isLoading = useAtomValue(visitorStateAtom) === VisitorState.JOINING;
  const { trackJoinSessionClicked } = useAdmissionTrackingEvents();

  return (
    <JoinSessionButton
      onJoin={() => {
        connectRoom();
        trackJoinSessionClicked();
      }}
      isLoading={isLoading}
    />
  );
}
